import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AdminLayout from '../../components/AdminLayout';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import '../admin/AdminPages.css';

const ManageFounders = () => {
  const [founders, setFounders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingFounder, setEditingFounder] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    role: '',
    description: '',
    linkedIn: '',
    order: 0
  });

  useEffect(() => {
    fetchFounders();
  }, []);

  const fetchFounders = async () => {
    try {
      const response = await axios.get('/api/founders');
      setFounders(response.data.data);
    } catch (error) {
      console.error('Error fetching founders:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingFounder) {
        await axios.put(`/api/founders/${editingFounder._id}`, formData);
      } else {
        await axios.post('/api/founders', formData);
      }
      fetchFounders();
      closeModal();
    } catch (error) {
      console.error('Error saving founder:', error);
      alert('Error saving founder. Please try again.');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this founder?')) {
      try {
        await axios.delete(`/api/founders/${id}`);
        fetchFounders();
      } catch (error) {
        console.error('Error deleting founder:', error);
        alert('Error deleting founder.');
      }
    }
  };

  const openModal = (founder = null) => {
    if (founder) {
      setEditingFounder(founder);
      setFormData({
        name: founder.name,
        role: founder.role,
        description: founder.description,
        linkedIn: founder.linkedIn || '',
        order: founder.order
      });
    } else {
      setEditingFounder(null);
      setFormData({
        name: '',
        role: '',
        description: '',
        linkedIn: '',
        order: 0
      });
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingFounder(null);
  };

  if (loading) {
    return (
      <AdminLayout title="Manage Founders">
        <div className="loading-state">Loading...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Manage Founders">
      <div className="admin-page">
        <div className="page-actions">
          <button className="btn-add" onClick={() => openModal()}>
            <FaPlus /> Add Founder
          </button>
        </div>

        <div className="data-table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Role</th>
                <th>Description</th>
                <th>Order</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {founders.map((founder) => (
                <tr key={founder._id}>
                  <td className="font-semibold">{founder.name}</td>
                  <td>{founder.role}</td>
                  <td className="description-cell">{founder.description.substring(0, 80)}...</td>
                  <td>{founder.order}</td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn-edit" onClick={() => openModal(founder)}>
                        <FaEdit />
                      </button>
                      <button className="btn-delete" onClick={() => handleDelete(founder._id)}>
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {founders.length === 0 && (
            <div className="no-data">No founders found. Add your first founder!</div>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2 className="modal-title">
              {editingFounder ? 'Edit Founder' : 'Add Founder'}
            </h2>
            <form onSubmit={handleSubmit} className="modal-form">
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label>Role *</label>
                <input
                  type="text"
                  value={formData.role}
                  onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                  required
                  placeholder="e.g., Co-Founder & CEO"
                />
              </div>

              <div className="form-group">
                <label>Description *</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  required
                  rows="4"
                />
              </div>

              <div className="form-group">
                <label>LinkedIn URL</label>
                <input
                  type="url"
                  value={formData.linkedIn}
                  onChange={(e) => setFormData({ ...formData, linkedIn: e.target.value })}
                  placeholder="https://linkedin.com/in/..."
                />
              </div>

              <div className="form-group">
                <label>Display Order</label>
                <input
                  type="number"
                  value={formData.order}
                  onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                />
              </div>

              <div className="modal-actions">
                <button type="button" className="btn-cancel" onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit" className="btn-save">
                  {editingFounder ? 'Update' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default ManageFounders;
